import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { SupportServiceTag } from '@src/api/types/supportServiceTag';

type CompanySupportServiceTagIndexResponse = SupportServiceTag[];

export const companySupportServiceTagApiClient = {
  index: async (): Promise<ApiResult<CompanySupportServiceTagIndexResponse>> => {
    return await axiosClient.get('/company/support-service-tags');
  },
};
